import { render, staticRenderFns } from "./OrderFabric.vue?vue&type=template&id=51f1767a&"
import script from "./OrderFabric.vue?vue&type=script&lang=js&"
export * from "./OrderFabric.vue?vue&type=script&lang=js&"
import style0 from "./OrderFabric.vue?vue&type=style&index=0&id=51f1767a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports